import { connect } from "react-redux";
import ApprovedSalesListing from "./approvedSalesListing";
import { bindActionCreators } from "redux";
import { getApprovedSaleListing } from "services/redux/sales/approvedSalesListing/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.approvedSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getApprovedSaleListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedSalesListing);
